import { Navigate, useParams } from 'react-router-dom';

import { LoanApplicationShell } from '@/components/CommercialLoanApplication/LoanApplicationShell';

export function CommercialLoanApplicationPage() {
  const { applicationId } = useParams<{ applicationId: string }>();
  if (!applicationId) {
    return <Navigate to="/loan" replace />;
  }
  return <LoanApplicationShell applicationId={applicationId} />;
}
